
namespace Matrix.Scheduling {

    @Serenity.Decorators.registerClass()
    export class CalendarGrid extends SiteEntityGrid<CalendarRow, any> {
        protected getColumnsKey() { return 'Scheduling.Calendar'; }
        protected getDialogType() { return CalendarDialog; }
        protected getIdProperty() { return CalendarRow.idProperty; }
        protected getInsertPermission() { return CalendarRow.insertPermission; }
        protected getLocalTextPrefix() { return CalendarRow.localTextPrefix; }
        protected getService() { return CalendarService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}